import { render } from "./WaterBarnSection.vue?vue&type=template&id=233b0971&ts=true"
import script from "./WaterBarnSection.vue?vue&type=script&lang=ts"
export * from "./WaterBarnSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__